import { Building2 } from "lucide-react";

/**
 * Compliance Roadmap Item 8 — shared Company Info block.
 *
 * Rendered at the bottom of every legal document (Terms, Privacy, DMCA
 * once it lands). Uses placeholder tokens the owner must replace before
 * publish. Nothing here is invented — every field is either a hard-coded
 * placeholder or a link to the ready path in the Service.
 *
 * Placeholders are wrapped in mustache braces (`{{LEGAL_ENTITY_NAME}}`)
 * on purpose so a simple project-wide grep finds every unfilled slot.
 */
export function LegalCompanyInfo({ testid = "legal-company-info", className = "" }) {
  return (
    <section
      data-testid={testid}
      className={`rounded-2xl border border-white/10 bg-[hsl(220_18%_10%)] p-5 sm:p-6 ${className}`}
    >
      <div className="flex items-start gap-3">
        <div className="h-10 w-10 rounded-xl bg-cyan-400/10 border border-cyan-300/30 flex items-center justify-center shrink-0">
          <Building2 className="h-5 w-5 text-cyan-300" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-cyan-300/80 mb-1">Company &amp; Contact</div>
          <h3 className="font-display text-lg text-white tracking-[0.04em]">Operator of the Service</h3>
          <dl className="mt-3 grid sm:grid-cols-2 gap-x-6 gap-y-2 text-[12.5px] leading-relaxed text-white/70 font-mono">
            <div><dt className="text-white/40 uppercase text-[10px] tracking-[0.18em]">Legal Entity</dt><dd className="text-white/85">{"{{LEGAL_ENTITY_NAME}}"}</dd></div>
            <div><dt className="text-white/40 uppercase text-[10px] tracking-[0.18em]">State of Incorporation</dt><dd className="text-white/85">{"{{STATE_OF_INCORPORATION}}"}</dd></div>
            <div className="sm:col-span-2"><dt className="text-white/40 uppercase text-[10px] tracking-[0.18em]">Business Mailing Address</dt><dd className="text-white/85 whitespace-pre-line">{"{{BUSINESS_MAILING_ADDRESS}}"}</dd></div>
            <div><dt className="text-white/40 uppercase text-[10px] tracking-[0.18em]">Support</dt><dd className="text-white/85">{"{{SUPPORT_EMAIL}}"}</dd></div>
            <div><dt className="text-white/40 uppercase text-[10px] tracking-[0.18em]">Legal</dt><dd className="text-white/85">{"{{LEGAL_EMAIL}}"}</dd></div>
            <div><dt className="text-white/40 uppercase text-[10px] tracking-[0.18em]">Privacy</dt><dd className="text-white/85">{"{{PRIVACY_EMAIL}}"}</dd></div>
            <div><dt className="text-white/40 uppercase text-[10px] tracking-[0.18em]">DMCA / Copyright</dt><dd className="text-white/85">{"{{DMCA_EMAIL}}"}</dd></div>
            <div><dt className="text-white/40 uppercase text-[10px] tracking-[0.18em]">Governing Law</dt><dd className="text-white/85">{"{{GOVERNING_LAW_STATE}}"}</dd></div>
            <div><dt className="text-white/40 uppercase text-[10px] tracking-[0.18em]">Dispute Venue</dt><dd className="text-white/85">{"{{DISPUTE_VENUE}}"}</dd></div>
            <div><dt className="text-white/40 uppercase text-[10px] tracking-[0.18em]">Effective</dt><dd className="text-white/85">{"{{EFFECTIVE_DATE}}"}</dd></div>
            <div><dt className="text-white/40 uppercase text-[10px] tracking-[0.18em]">Last Updated</dt><dd className="text-white/85">{"{{LAST_UPDATED_DATE}}"}</dd></div>
          </dl>
          <p className="text-[11px] text-amber-200/70 mt-4 leading-relaxed">
            The bracketed values above are placeholders the Operator must complete before publishing. Until they are filled in, contact through the Service&apos;s in-app support channel.
          </p>
        </div>
      </div>
    </section>
  );
}

export default LegalCompanyInfo;
